import { Player } from '../../../../types';
import { convertTime, Time } from '../../../../lib/utils/dateUtils';
import { mod } from '../../../../lib/utils/math';

export const formatTimes = (startTime: number): string => {
  const isLessThanHour = startTime < convertTime(1, Time.Hours, Time.Seconds);
  const hours = Math.floor(convertTime(startTime, Time.Seconds, Time.Hours)).toLocaleString(undefined, {
    minimumIntegerDigits: 2,
  });
  const minutes = Math.floor(mod(convertTime(startTime, Time.Seconds, Time.Minutes), 60)).toLocaleString(undefined, {
    minimumIntegerDigits: 2,
  });
  const seconds = Math.floor(mod(startTime, 60)).toLocaleString(undefined, { minimumIntegerDigits: 2 });

  return `${isLessThanHour ? '' : `${hours}:`}${minutes}:${seconds}`;
};

export const startVideo = (player: Player) => {
  player?.muted(false);
  player?.play().catch(() => {
    player?.muted(true);
    player?.play();
  });
};

export const getCueStartTime = (time: number, cueList: TextTrackCueList | null) =>
  Array.from(cueList ?? []).find(cue => time >= cue.startTime && time < cue.endTime)?.startTime ?? 0;

export const isTimeInRange = (startTime: number, endTime: number, currentTime: (number | null)[] | number | null) => {
  if (currentTime === null) {
    return false;
  }
  if (Array.isArray(currentTime)) {
    return currentTime.some(time => time !== null && time >= startTime && time < endTime);
  }

  return currentTime >= startTime && currentTime < endTime;
};
